/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { SetActiveTool } from './active-tool.actions';
import { ActiveToolModel } from './active-tool.model';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { DashGisUtil } from '../../../../shared/dash-gis-util';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';

@State<ActiveToolModel>({
    name: 'activeTool',
    defaults: {
        activeTool: 'Pan'
    }
})
@Injectable()
export class ActiveToolState {

    defaultTool = 'Pan';

    @Action(SetActiveTool)
    public setActiveTool({setState}: StateContext<ActiveToolModel>, action: SetActiveTool) {
        const newTool = action.payload.name || this.defaultTool;
        setState(patch({ activeTool: newTool }));
    }

    @Selector()
    public static activeTool(state: ActiveToolModel) {
        return state.activeTool;
    }
}

